@if(form()){
<form [formGroup]="form()">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
        <spike-field-select [initialValue]="organizationStore.getEmployee(form().controls['reference']?.value??0)()" formControlName="reference" label="Referente" selectKey="employeeId" selectValue="shortDescription" listTitle="Seleziona operatore" detailTitle="dettaglio operatore" placeholder="Seleziona referente">
            <ng-template #list>
                <spike-organization-list #listRef
                [modelApi]="employeeModelApi"
                [entityApi]="employeeApi"
                [etiquetteApi]="employeeEtiquetteApi"
                entityKey="employeeId">
                </spike-organization-list>

            </ng-template>
        </spike-field-select>
        @if(workflowPhase()==1){
        <spike-field-date  icon ="pi pi-calendar" label="Data Invio Offerta" formControlName ="sendDate"></spike-field-date>
        <spike-field-date  icon ="pi pi-calendar" label="Data Scadenza Offerta" formControlName ="expireDate" ></spike-field-date>
        }
        @if(workflowPhase()==2){
        <spike-field-date  icon ="pi pi-calendar" label="Data Progettazione" formControlName ="sendDate"></spike-field-date>
        }
        @if(workflowPhase()==3){
        <spike-field-date  icon ="pi pi-calendar" label="Data Inizio" formControlName ="sendDate"></spike-field-date>
        <spike-field-date  icon ="pi pi-calendar" label="Data Fine" formControlName ="expireDate" ></spike-field-date>
        }
    </div>
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
        <spike-field-number  label="Totale calcolato" formControlName ="totalCalculated" [readOnly]="true" mode="currency" currency="EUR"></spike-field-number>
        <spike-field-number  label="Margine di Profitto (%)" formControlName ="profitMarginPerc" [readOnly]="true" suffix="%"></spike-field-number>
        <spike-field-number  label="Totale" formControlName ="total" mode="currency" currency="EUR"></spike-field-number>
    </div>
    <spike-field-text-area label="Note" formControlName ="description" ></spike-field-text-area>

</form>
}
